import type { BehaviorDefinition } from "./types";

import { SHARED_BEHAVIORS } from "./shared";

/** Verizon behavior catalog (the Ascend pilot). Array order is call-flow order. */
export const VERIZON_BEHAVIORS: readonly BehaviorDefinition[] = [
    // ── Serve ─────────────────────────────────────────────────────────────
    SHARED_BEHAVIORS.greeting,
    SHARED_BEHAVIORS.ask_effective_questions,
    SHARED_BEHAVIORS.scope,
    SHARED_BEHAVIORS.show_compassion,
    SHARED_BEHAVIORS.provide_assurance,
    SHARED_BEHAVIORS.verify_the_customer,
    SHARED_BEHAVIORS.account_assessment,
    SHARED_BEHAVIORS.positive_and_helpful_tone,
    SHARED_BEHAVIORS.demonstrate_professionalism_and_courtesy,
    SHARED_BEHAVIORS.actively_listen,
    SHARED_BEHAVIORS.keep_customer_informed,
    SHARED_BEHAVIORS.manage_call_efficiently,
    SHARED_BEHAVIORS.build_confidence_through_language,
    SHARED_BEHAVIORS.protect_customer_information,
    SHARED_BEHAVIORS.act_as_a_representative_of_our_brand,
    SHARED_BEHAVIORS.use_tools_to_diagnose,
    SHARED_BEHAVIORS.follow_steps_in_tools,
    SHARED_BEHAVIORS.follow_warranty_process,
    SHARED_BEHAVIORS.follow_call_message_back_procedures,
    SHARED_BEHAVIORS.provide_self_service_options,
    SHARED_BEHAVIORS.resolve_the_customers_issue,
    SHARED_BEHAVIORS.recap,
    SHARED_BEHAVIORS.follow_the_proper_transfer_procedures,
    SHARED_BEHAVIORS.discovery_question,
    SHARED_BEHAVIORS.test_troubleshooting_was_effective,
    SHARED_BEHAVIORS.read_non_sales_disclosures,
    SHARED_BEHAVIORS.capture_complete_notes_in_systems,
    SHARED_BEHAVIORS.follow_system_prompts,
    // ── Sell — Smart Offer ────────────────────────────────────────────────
    SHARED_BEHAVIORS.make_an_offer,
    SHARED_BEHAVIORS.transition_statement,
    SHARED_BEHAVIORS.ask_to_send_guided_browsing_link,
    SHARED_BEHAVIORS.smart_offer_conversational_language,
    SHARED_BEHAVIORS.core_benefits,
    SHARED_BEHAVIORS.examples_of_coverage,
    SHARED_BEHAVIORS.early_rebuttal,
    SHARED_BEHAVIORS.resolve_concern,
    SHARED_BEHAVIORS.price,
    SHARED_BEHAVIORS.ask_for_sale,
    SHARED_BEHAVIORS.ask_to_send_enrollment_link,
    SHARED_BEHAVIORS.complete_enrollment_guided_browsing,
    SHARED_BEHAVIORS.celebrate_enrollment,
    SHARED_BEHAVIORS.accurate_sales_tracking,
    SHARED_BEHAVIORS.multi_product_offer_in_right_order,
    // ── Sell — Closing ────────────────────────────────────────────────────
    SHARED_BEHAVIORS.branded_closing,
];
